<div tabindex="0" (click)="close.emit(true)"></div>